import { Box, Group } from "@mantine/core";
import type { ReactNode } from "react";

/**
 * The primary action, pinned to the bottom.
 *
 * One of the six problems found by driving the built app: on the longer
 * capture sheets the button a screen exists for scrolls off the bottom, so
 * the user hunts for the thing they came to do.
 *
 * `safe-bottom` is not decoration. Without the inset a fixed bar sits under
 * an iPhone's home indicator, where the last few pixels of the primary button
 * cannot be tapped at all.
 */
export function StickyActionBar({
  primary,
  secondary,
  context,
  /** Extra bottom offset, for a screen that also shows the bottom nav. */
  offset = 0,
}: {
  primary: ReactNode;
  secondary?: ReactNode;
  /** A right-hand label - "Total payable ₹1,200". */
  context?: ReactNode;
  offset?: number;
}) {
  return (
    <Box
      className="safe-bottom"
      style={{
        position: "sticky",
        bottom: offset,
        marginTop: "var(--mantine-spacing-md)",
        padding: "var(--mantine-spacing-md)",
        background: "var(--mantine-color-white)",
        borderTop: "1px solid var(--mantine-color-gray-3)",
        zIndex: 2,
      }}
    >
      <Group justify="space-between" wrap="nowrap" gap="sm">
        {secondary}
        {context}
        <Box style={{ flex: secondary || context ? "0 0 auto" : 1 }}>{primary}</Box>
      </Group>
    </Box>
  );
}
